// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MarkerIcon{width:40px;height:50px}", "",{"version":3,"sources":["webpack://./src/components/widgets/airport/map/map-marker/map-marker.scss"],"names":[],"mappings":"AAAA,YACI,UAAA,CACA,WAAA","sourcesContent":[".MarkerIcon {\n    width: 40px;\n    height: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
